import React, { useEffect, useRef, useState } from 'react'
import CustomSelect from '../Common/CustomSelect';
import * as utilities from "../../utilities/utils";
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as filterActions from "../../redux/actions/filterAction";

const ApplicationFilter = (props) => {
    const initialState = {

        filterText: {
            value: null,
        }
    }

    const [state, setState] = useState(initialState);

    const dispatch = useDispatch();

    useEffect(() => {
        filterAction.setFilterApplication(state.filterText.value ? state.filterText.value : "", profileReducer);
    }, [state.filterText.value])

    const filterApplicationState = useSelector(
        (state) => state.filterReducer
    );

    const profileReducer = useSelector(
        (state) => state.profileReducer
    );

    const filterAction = bindActionCreators(filterActions, dispatch);
    const onDrpInputchange = (searchText) => {
        // if (searchText) {
        //     filterAction.setFilterApplication(searchText, profileReducer);
        // }
        // // else {
        // //     filterAction.resetFilterApplication();
        // // }
        let updatedObj = state.filterText;
        updatedObj.value = searchText;
        setState((state) => {
            return {
                ...state,
                filterText: updatedObj,
            };
        });

    }
    return (
        <>
            <div className="filter-row row">
                <div className="col-sm-6 col-md-6">
                    <CustomSelect
                        placeholder={props.context.t(
                            "STD-Employer-Statement.form.label.search-Employee-EIN-LastName.text"
                        )}
                        name="accountInfoId"
                        className="search-emp-select"
                        values={props.selectedFilterValue.value ? props.selectedFilterValue.value : undefined}
                        handleChange={(selectItems, event) => {
                            props.onFilterDropDownChange(selectItems, event)
                        }}
                        inputValue={state.inputValue}
                        onInputChange={(value) => {
                            onDrpInputchange(value)
                        }}
                        options={utilities.prepareOptionMulDis(filterApplicationState.filterApplicationValues ? filterApplicationState.filterApplicationValues : [], "externalID", ["clientLastName", "clientFirstName"])}
                    />
                </div>
            </div>
        </>

    )
}

export default ApplicationFilter;